import { ColocaLogo } from "@/shared/components/ColocaLogo";
import useTranslations from "@/shared/lang/useTranslations";

export interface StatementFooterProps {
  issuedAtLabel: string;
  pageIndex: number;
  pageCount: number;
  /** Rendered only on the last page so the notes appear once per document. */
  showNotes: boolean;
  hasDeclined: boolean;
  isEstimated: boolean;
  holderFromCardFallback: boolean;
  truncated: boolean;
  shownCount: number;
  totalCount: number;
}

export const StatementFooter = ({
  issuedAtLabel,
  pageIndex,
  pageCount,
  showNotes,
  hasDeclined,
  isEstimated,
  holderFromCardFallback,
  truncated,
  shownCount,
  totalCount,
}: StatementFooterProps) => {
  const { t } = useTranslations("cards");

  return (
    <footer className="mt-auto border-t border-border px-10 pb-6 pt-3">
      {showNotes && (
        <div className="mb-2 space-y-0.5 text-[8.5px] leading-snug text-muted-foreground">
          {isEstimated && <p>{t("statement_footnote_reconciliation")}</p>}
          {holderFromCardFallback && <p>{t("statement_holder_source_fallback_note")}</p>}
          {hasDeclined && <p>{t("statement_footer_declined_excluded")}</p>}
          {truncated && (
            <p>
              {t("statement_footnote_truncated", {
                shown: shownCount,
                total: totalCount,
              })}
            </p>
          )}
        </div>
      )}

      <div className="flex items-end justify-between gap-4 text-[9px] leading-snug text-muted-foreground">
        <div className="min-w-0">
          <p>{t("statement_footer_issued", { date: issuedAtLabel })}</p>
          <ColocaLogo variant="black" className="mt-1 [&>img]:h-3 [&>img]:w-auto" />
        </div>
        <p className="shrink-0 font-mono tabular-nums">
          {t("statement_footer_page", { current: pageIndex + 1, total: pageCount })}
        </p>
      </div>
    </footer>
  );
};
